export default __webpack_public_path__ + "static/media/010910_757.05d83d36.jpg";